module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h14"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("First and foremost, thank you to Raine for asking me to be a part of "), _c('span', {
    staticClass: "t2"
  }, [_vm._v("Piece Us Back Together")]), _vm._v(". It has been so much fun, and it finally gave a voice to the man who was the real-life inspiration behind Matthew. Thank you to Star, Mariah, and Andrew for their friendship, support, beta-reading talents, and advice.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "t3"
  }, [_vm._v("And as always, thank you to the wonderful staff at Dreamspinner Press, with a special thank you to Tricia, Brian, Anastasia, Cyndy, and Rose.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a756e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/003.vue
// module id = 60
// module chunks = 0